import api from '../../apiConfig/apiConfig';
import { Get, Post, Patch, Put } from '../base/baseAjax';

let getOrderwebsitepage = param => {
	return Post({
		url: api.website.orderwebsitepage,
		bodyParam: param,
	});
};

let getOrderwebsiteinfo = param => {
	return Get({
		url: api.website.orderwebsiteinfo,
		PathParam: param,
	});
};

let getWebsitelist = param => {
	return Post({
		url: api.website.websitelist,
		bodyParam: param,
		config: {
			timeout: 60000,
		},
	});
};

let getOrderQuery = param => {
	return Get({
		url: api.website.orderQuery,
		UrlParam: param,
	});
};

let getCreatewebtkd = param => {
	return Post({
		url: api.website.getCreatewebtkd,
		bodyParam: param,
	});
};

function getInquiryMail(param) {
	return Get({
		url: api.website.getInquiryMail,
		PathParam: param,
	});
}

function analysisTxt(param) {
	return Post({
		url: api.website.analysisTxt,
		bodyParam: param,
	});
}

function analysisMail(param) {
	return Post({
		url: api.website.emailAnalysis,
		bodyParam: param,
	});
}

// 邮箱解绑
function emailUnbind(param) {
	return Post({
		url: api.website.emailUnbind,
		bodyParam: param,
	});
}

function addAnalysisMail(param) {
	return Post({
		url: api.website.addAnalysisMail,
		bodyParam: param,
	});
}
export function bindNode(param) {
	return Post({
		url: api.website.bindNode,
		bodyParam: param,
	});
}
export function unbindNode({ id, type = 0 }) {
	return Get({
		url: `${api.website.unbindNode}${id}/${type} `,
		config: {
			timeout: 60000,
		},
	});
}
export function release(param) {
	return Post({
		url: api.website.release,
		bodyParam: param,
	});
}
export function getUploadInfo(param) {
	return Post({
		url: api.website.getUploadInfo,
		bodyParam: param,
	});
}
export function getSiteDetail(id) {
	return Get({
		url: api.website.getSiteDetail + id,
	});
}
export function upload(param) {
	return Post({
		url: api.website.siteUpload,
		bodyParam: param,
	});
}
export function getNodeList(param) {
	return Post({
		url: api.website.getNodeList,
		bodyParam: param,
	});
}
export function updateDomain(param) {
	return Post({
		url: api.website.updateDomain,
		bodyParam: param,
	});
}
export function getAliDomainList(id) {
	return Get({
		url: api.website.getAliDomainList + id,
	});
}
export function getSiteList(param) {
	return Post({
		url: api.website.getSiteList,
		bodyParam: param,
	});
}
export function editWebsite(param) {
	return Post({
		url: api.website.editWebsite,
		bodyParam: param,
	});
}
export function bindEmail(param) {
	return Post({
		url: api.website.bindEmail,
		bodyParam: param,
	});
}
//绑定ga账户
export function bindGaAccount(param) {
	return Patch({
		url: api.website.bindGaAccount,
		PathParam: param,
		bodyParam: param,
	});
}
//绑定GTM账户
export function bindGTMAccount(param) {
	return Patch({
		url: api.website.bindGTMAccount,
		PathParam: param,
		UrlParam: {
			gaId: param.gaId,
			mccAccountId: param.mccAccountId,
			containerPath: param.containerPath,
		},
	});
}

// 获取GA绑定详情
export function getDetail(param) {
	return Get({
		url: api.website.getDetail,
		PathParam: param,
	});
}
export function bindBdAccount(param) {
	//绑定百度账户
	return Post({
		url: api.website.bindBdAccount,
		bodyParam: param,
	});
}
export function addCdnDomain(param) {
	return Post({
		url: api.website.addCdnDomain,
		bodyParam: param,
	});
}
export function refreshCdnDomain(param) {
	return Post({
		url: api.website.refreshCdnDomain,
		bodyParam: param,
	});
}
export function refreshCdnStatus(param) {
	return Post({
		url: api.website.refreshCdnStatus,
		bodyParam: param,
	});
}

export function compileWebsiteUrl(params) {
	return Patch({
		url: api.website.compileWebsiteUrl + params.id,
		bodyParam: {
			websitePreviewUrl: params.url,
		},
	});
}

export function googlereports(params) {
	return Post({
		url: `${api.website.googlereports}?customerId=${params.customerId}`,
		bodyParam: params,
		config: {
			timeout: 60000,
		},
	});
}
export function googlederive(params) {
	return Post({
		url: `${api.website.googlederive}?customerId=${params.id}`,
		bodyParam: params,
		config: {
			responseType: 'blob',
		},
	});
}
let searchTermsDownload = parmas => {
	return Post({
		url: api.website.searchTermsDownload,
		bodyParam: parmas,
		config: {
			responseType: 'blob',
			timeout: 60000,
		},
	});
};

let advertisingSeries = params => {
	return Post({
		url: api.website.advertisingSeries,
		bodyParam: params,
		config: {
			timeout: 60000,
		},
	});
};
let advertisingGroup = params => {
	return Post({
		url: api.website.advertisingGroup,
		bodyParam: params,
		config: {
			timeout: 60000,
		},
	});
};
let advertisingSubmitSeries = params => {
	return Get({
		url: api.website.advertisingSubmitSeries,
		PathParam: params,
	});
};
let advertisingSubmitGroup = params => {
	return Post({
		url: `${api.website.advertisingSubmitGroup}`,
		PathParam: { service_id: params.service_id },
		bodyParam: params.id,
	});
};
let advertisingSubmitDownload = params => {
	return Post({
		url: `${api.website.advertisingSubmitDownload}`,
		bodyParam: params,
		config: {
			responseType: 'blob',
			timeout: 60000,
		},
	});
};

let bindleadfeeder = params => {
	return Post({
		url: api.website.visitantIdentify,
		bodyParam: params,
	});
};

// 访客识别解绑
let unbindleadfeeder = params => {
	return Post({
		url: api.website.unbindleadfeeder,
		bodyParam: params,
	});
};

let getFormInquiryList = params => {
	return Post({
		url: api.website.getFormInquiryList,
		bodyParam: params,
	});
};

let setCode = params => {
	return Post({
		url: api.website.setCode,
		PathParam: params,
	});
};

let websiteCode = params => {
	return Patch({
		url: api.website.websiteCode,
		PathParam: params,
	});
};

let getDomainlist = params => {
	return Get({
		url: api.website.getDomainlist,
		UrlParam: params,
	});
};
let associate = params => {
	return Post({
		url: api.website.associate,
		PathParam: params,
	});
};
let goal = params => {
	return Post({
		url: api.website.goal,
		PathParam: params,
	});
};
let tags = params => {
	return Post({
		url: api.website.tags,
		PathParam: params,
	});
};

let gtmTraceConfig = params => {
	return Post({
		url: api.website.gtmTraceConfig,
		PathParam: params,
	});
};

let tagsMarket = params => {
	return Post({
		url: api.website.tagsMarket,
		bodyParam: params,
	});
};
let tagsMarketPublish = params => {
	return Post({
		url: api.website.tagsMarketPublish,
		PathParam: params,
	});
};
let gtmDetails = params => {
	return Post({
		url: api.website.gtmDetails,
		PathParam: params,
	});
};
let setindustry = (param, params) => {
	return Post({
		url: api.website.setindustry,
		PathParam: param,
		bodyParam: params,
	});
};
let getConversionId = params => {
	return Get({
		url: api.website.getConversionId,
		PathParam: params,
	});
};

// 查看访客自定义分组
let getCheckgroup = params => {
	return Post({
		url: api.website.getCheckgroup,
		bodyParam: params,
	});
};

// GSC账号授权
let addGsc = params => {
	return Put({
		url: api.website.addGsc,
		bodyParam: params,
	});
};
let campaign_device = params => {
	return Post({
		url: `${api.website.campaign_device}?serviceSiteId=${params.serviceId}`,
		bodyParam: params,
	});
};
let campaign_deviceExport = params => {
	return Post({
		url: `${api.website.campaign_deviceExport}?serviceSiteId=${params.serviceId}`,
		bodyParam: params,
		config: {
			responseType: 'blob',
		},
	});
};

// GTM-开启增强型潜在客户转化一键配置
let addEnhancedConversions = param => {
	return Post({
		url: api.website.addEnhancedConversions,
		PathParam: param,
	});
};

// GTM-关闭增强型潜在客户转化一键配置
let removeEnhancedConversions = param => {
	return Post({
		url: api.website.removeEnhancedConversions,
		PathParam: param,
	});
};


// 开启Google代码网关一键配置
let addGoogleTagGateway = param => {
	return Post({
		url: api.website.addGoogleTagGateway,
		PathParam: param,
	});
};

// 关闭Google代码网关一键配置
let removeGoogleTagGateway = param => {
	return Post({
		url: api.website.removeGoogleTagGateway,
		PathParam: param,
	});
};

export default {
	getOrderwebsitepage: getOrderwebsitepage,
	getOrderwebsiteinfo: getOrderwebsiteinfo,
	getWebsitelist: getWebsitelist,
	getOrderQuery: getOrderQuery,
	upload,
	bindNode,
	unbindNode,
	release,
	getUploadInfo,
	getSiteDetail,
	getNodeList,
	updateDomain,
	getAliDomainList,
	getSiteList,
	editWebsite,
	bindEmail,
	bindGaAccount,
	bindGTMAccount,
	getDetail,
	getCreatewebtkd,
	bindBdAccount,
	compileWebsiteUrl,
	googlederive,
	googlereports,
	getInquiryMail,
	analysisTxt,
	analysisMail,
	emailUnbind,
	addAnalysisMail,
	searchTermsDownload,
	advertisingSeries,
	advertisingGroup,
	advertisingSubmitSeries,
	advertisingSubmitGroup,
	advertisingSubmitDownload,
	bindleadfeeder,
	unbindleadfeeder,
	getFormInquiryList,
	setCode,
	websiteCode,
	getDomainlist,
	associate,
	goal,
	tags,
	gtmTraceConfig,
	tagsMarket,
	tagsMarketPublish,
	gtmDetails,
	setindustry,
	getConversionId,
	getCheckgroup,
	addGsc,
	campaign_device,
	campaign_deviceExport,
	addEnhancedConversions,
	removeEnhancedConversions,
  addGoogleTagGateway,
  removeGoogleTagGateway,
};
